module.exports = __webpack_public_path__ + "static/media/管理.f4112dc4.svg";